import { useTranslation } from 'react-i18next';
import { Card } from 'reactstrap';
import BaseLoader from './parts/BaseLoader';

import { FilterList } from './parts/PeriodsSelector';
import SectionsRegistrationMassiveTable from './parts/SectionsRegistrationMassiveTable';

export default function SectionsRegistrationMassive() {
  const { t } = useTranslation();
  return (
    <div className="mx-3">
      <Card className="p-4">
        <div className="mb-3 fs-16">
          {t('sectionsRegistrationMassive.description')}
        </div>
        <BaseLoader>
          {({ data }) => <FilterList {...data}></FilterList>}
        </BaseLoader>
        <SectionsRegistrationMassiveTable />
      </Card>
    </div>
  );
}
